import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <p>Designed and Built by Sofia Sawczenko.</p>
    </div>
  );
};

export default Footer;
